export const SPLIT_ENDPOINTS_ENABLED = "frontend.configuration.splitEndpoints.enabled";
const SESSION_LOGOUT_REQUEST = "session/LOGOUT_REQUEST";

export const CONFIG_SOURCE_SPLIT = "split";
export const CONFIG_SOURCE_LEGACY = "legacy";

export const types = {
    UPDATE_REQUEST: "config/UPDATE_REQUEST",
    PRE_LOGIN_UPDATE_SUCCESS: "config/PRE_LOGIN_UPDATE_SUCCESS",
    UPDATE_SUCCESS: "config/UPDATE_SUCCESS",
    UPDATE_FAILURE: "config/UPDATE_FAILURE",
    RESET_SAGAS_UPDATE: "config/RESET_SAGAS_UPDATE",
};

export const INITIAL_STATE = {
    fetching: true,
    items: {},
    preLoginItems: {},
    timesFailed: 0,
};

export function isSplitEndpointsEnabled(items = {}) {
    return items[SPLIT_ENDPOINTS_ENABLED] === "true";
}

export default (state = INITIAL_STATE, action = {}) => {
    switch (action.type) {
        case types.UPDATE_REQUEST:
            return { ...state, fetching: true };

        case types.PRE_LOGIN_UPDATE_SUCCESS:
            return { ...state, preLoginItems: action.items };

        case types.UPDATE_SUCCESS:
            return { ...state, fetching: false, items: action.items, source: action.source, timesFailed: 0 };

        case types.UPDATE_FAILURE:
            return { ...state, fetching: false, timesFailed: state.timesFailed + 1 };

        case SESSION_LOGOUT_REQUEST:
            // ARBCMFIMP-19874: items may come from split endpoints even when the BO switch reads "false"
            // (legacy disabled), so rely on the load source and not only on the switch value.
            return state.source === CONFIG_SOURCE_SPLIT || isSplitEndpointsEnabled(state.items)
                ? {
                      ...state,
                      fetching: true,
                      items: state.preLoginItems || {},
                  }
                : state;

        default:
            return state;
    }
};

export const actions = {
    load: () => ({
        type: types.LOAD,
    }),
    updateConfig: () => ({
        type: types.UPDATE_REQUEST,
    }),
};

/**
 * @param {object} state
 * @param {string} id - Config key (backend sends string values; `"true"` enables the flag).
 * @param {boolean} [defaultWhenMissing=false] - When the key is absent from config (e.g. loading or not in DB).
 *        If present, explicit `"false"` / `"true"` in `items[id]` wins.
 */
function getConfigKey(state, id, defaultWhenMissing = false) {
    const raw = state.config.items[id];
    if (raw === undefined || raw === null || raw === "") {
        return defaultWhenMissing;
    }
    return raw === "true";
}

export const selectors = {
    getConfig: (state) => state.config.items,
    getPreLoginConfig: (state) => state.config.preLoginItems || {},
    getConfigKey,
    getFetching: (state) => state.config.fetching,
    getTimesFailed: (state) => state.config.timesFailed,
};
